/**
 * Created by Administrador on 10/24/2016.
 */
(function(){
    'use strict';

    var wizardStep = {
        transclude: true,
        template: '<div id="{{vm.target}}" class="tab-pane wizard-step" ng-show="vm.wizard.selected" ng-transclude ng-class="{active: vm.wizard.selected, fade: vm.wizard.selected, in: vm.wizard.selected}"></div>',
        controller: wizardStepController,
        controllerAs: 'vm',
        require: {
            'parent': '^wizard'
        },
        bindings:{
            heading: '@',
            target: '@',
            key: '@',
            formValidate: '='
        }
    }

    angular
        .module('completeAir')
        .component('wizardStep', wizardStep);

    function wizardStepController(){
        var vm = this;

        vm.$onInit = function(){
            vm.validate = (vm.validate != undefined) ? vm.validate : false;

            vm.wizard = {
                heading: vm.heading,
                target: vm.target,
                key: vm.key,
                selected: false,
                formValidate: vm.validate
            }
            vm.parent.addWizard(vm.wizard);
        }

        vm.$onChanges = function($event){
        }
    }
})();
